import { FragmentDefiner, useReadFragment } from "../../../GlobalHooks/useReadFragment";
import { useSendTextLead } from "../../../GlobalHooks/useSendLead";
import { PropComponentMode } from "../PropertyInterfaces";

export const FRAGMENT_MAP = new FragmentDefiner(
	"Property",
	`
    latitude
    longitude
    project {
        id
    }
`
);

export const usePropertyMap = ({
	id,
	mode = "auto",
	isProject,
}: {
	id: string;
	mode: PropComponentMode;
	isProject: boolean;
}) => {

	const { sendLead, loading: loadingSendLead } = useSendTextLead({
		property_id: id,
		entity_type: (isProject && mode == "auto") || mode == "project" ? "PROJECT" : "PROPERTY",
		financing_information: false,
		isAutoGenerated: false,
		source: 14,
		message: "Me gustaría ver la ubicación de la propiedad",
	});

	return {
		loadingSendLead,
		sendLead,
	};
};
